<div class="container" #container [class.disabledInput]="isDisabled">
    <div
        class="input-wrapper"
        [class.dark]="dark"
        [class.selecting]="isShowSelect"
        (click)="openSelect()"
        [style.cursor]="isDisabled ? 'not-allowed' : 'pointer'">
        <p
            class="input-label"
            [class.dark]="dark"
            [class.show]="!isDisabled && (isShowSelect || inputValue)"
            [class.selecting]="isShowSelect">
            {{ label | translate }}
        </p>

        <input
            [name]="name"
            [value]="isDisabled ? '' : (inputValue | translate)"
            [placeholder]="isShowSelect ? '' : (label | translate)"
            readonly
            [class.dark]="dark" />

        <div class="arrow-wrapper" [class.dark]="dark">
            <mat-icon class="arrow" [class.focus]="isShowSelect" svgIcon="dropdown-arrow"></mat-icon>
        </div>
    </div>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="container"
        [cdkConnectedOverlayOpen]="isShowSelect"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayWidth]="container.offsetWidth"
        [cdkConnectedOverlayPanelClass]="'custom-select-overlay-panel'"
        [cdkConnectedOverlayPositions]="[
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 2,
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
                offsetY: -2,
            },
        ]">
        <div
            class="select-list-container"
            [class.dark]="dark"
            [ngStyle]="{
                maxHeight: height ? height + 'px' : 'auto',
            }">
            <div *ngFor="let item of itemList" class="select-list">
                <div
                    class="item"
                    [class.dark]="dark"
                    [class.selected]="isSelected(item) && !isMultipleSelection"
                    (click)="selectValue($event, item)">
                    <mat-checkbox
                        *ngIf="isMultipleSelection"
                        class="item-checkbox"
                        [checked]="isSelected(item)"
                        [disableRipple]="true"></mat-checkbox>

                    <span class="item-label">
                        {{ getDisplayValue(item) | translate }}
                    </span>
                </div>
            </div>
        </div>
    </ng-template>
</div>
